import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import MembershipCTA from './components/MembershipCTA';
import BrandAdvantages from './components/BrandAdvantages';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedVideos />
        <MembershipCTA />
        <BrandAdvantages />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}